import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "linkedin",
  "use": "linkedin-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol viewBox=\"0 0 22 22\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"linkedin\">\n<path d=\"M22 18.9444C22 20.6323 20.6323 22 18.9444 22H3.05556C1.36828 22 0 20.6323 0 18.9444V3.05556C0 1.36767 1.36828 0 3.05556 0H18.9444C20.6323 0 22 1.36767 22 3.05556V18.9444Z\" fill=\"#0288D1\" />\n<path d=\"M5.5 8.70833H7.79167V16.5H5.5V8.70833ZM6.63896 7.79167H6.62612C5.94229 7.79167 5.5 7.282 5.5 6.64537C5.5 5.995 5.95604 5.5 6.65225 5.5C7.34938 5.5 7.77883 5.995 7.79167 6.64537C7.79167 7.28154 7.34937 7.79167 6.63896 7.79167ZM16.5 16.5H14.2083V12.3296C14.2083 11.3222 13.6469 10.6347 12.7453 10.6347C12.0574 10.6347 11.6852 11.0985 11.5046 11.5468C11.4386 11.7072 11.4583 12.1509 11.4583 12.375V16.5H9.16667V8.70833H11.4583V9.90733C11.7888 9.39583 12.3063 8.70833 13.6299 8.70833C15.2698 8.70833 16.4995 9.73958 16.4995 12.0423L16.5 16.5Z\" fill=\"white\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/sharedComponents/Icon/images/linkedin.svg
// module id = 9Rhw
// module chunks = 13